import { forwardRef } from 'react';

export interface AuthSplitCopyProps {
  eyebrow: string;
  headline: string;
  body: string;
}

/** Left-side welcome copy on auth split pages — pairs with AuthSplitDecor. */
export const AuthSplitCopy = forwardRef<HTMLDivElement, AuthSplitCopyProps>(
  function AuthSplitCopy({ eyebrow, headline, body }, ref) {
    return (
      <div ref={ref} className="auth-split-copy">
        <p className="auth-split-eyebrow">{eyebrow}</p>
        <h2 className="auth-split-headline">{headline}</h2>
        <p className="auth-split-body">{body}</p>
      </div>
    );
  },
);
